import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import KalkulatorBlock from './../block/Kalkulator'
import Kontakti from './../block/Kontakti'

class Kalkulator extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <KalkulatorBlock
          data={data?.kviz || []}
          assets_path={assets_path}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Kalkulator.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Kalkulator.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Kalkulator